var map = {
	"./lang/ar.png": 62825,
	"./lang/az.png": 74929,
	"./lang/de.png": 76193,
	"./lang/en.png": 13769,
	"./lang/ru.png": 87015,
	"./lang/tr.png": 65966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82084;